import { render, staticRenderFns } from "./Vin.vue?vue&type=template&id=60c50669"
import script from "./Vin.vue?vue&type=script&lang=js"
export * from "./Vin.vue?vue&type=script&lang=js"
import style0 from "./Vin.vue?vue&type=style&index=0&id=60c50669&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports